export default __webpack_public_path__ + "static/media/mcmc-vertical.250c7271.png";